import CommunicationPanel from '@uvocore-front/communication-panel';

// eslint-disable-next-line no-unused-vars
const communicationPanel = new CommunicationPanel({
  colors: {
    brandColor: '#e21523',
  },
});

window.communicationPanel = communicationPanel;
